// extracted by mini-css-extract-plugin
export default {"container":"GameOver_container__IGLZt"};